if (typeof L === "function" && window.L?.map) {
    L = window.L;
}
